import { BottomBarSelect } from '../../components/BottomBarSelect';
import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import LinkBlock from './LinkBlock';

const linkBlockPlugin: any = {
  Renderer: ({ data }: any) => (
    <div className="link-block-plugin">
      <LinkBlock
        title={data?.title}
        openInNewWindow={data?.openInNewWindow}
        hideIcon={data?.hideIcon}
        icon={data?.style?.icon}
        iconBackground={data?.style?.iconBackground}
        iconColor={data?.style?.iconColor}
        bgColor={data?.style?.bgColor}
        textColor={data?.style?.textColor}
        // titlePosition={data?.style?.titlePosition}
        blockPosition={data?.style?.blockPosition}
        titleType={data?.style?.titleType}
        padding={data?.style?.padding}
        documentLink={data?.documentLink}
      />
    </div>
  ),
  id: 'linkBlockPlugin',
  title: 'Link Block',
  description:
    'A block with an Icon and text that can be a link to another document',
  version: 1,
  controls: [
    {
      title: 'Default Config',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            title: {
              type: 'string',
              default: 'Title',
            },
            documentLink: {
              type: 'string',
              default: '',
            },
            hideIcon: {
              type: 'boolean',
              default: false,
            },
            openInNewWindow: {
              type: 'boolean',
              default: false,
            },
          },
          required: ['title'],
        },
      },
    },
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        columnCount: 2,
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                textColor: {
                  type: 'string',
                  default: 'rgba(34,34,34,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Text Color: ',
                  },
                },
                bgColor: {
                  type: 'string',
                  default: 'rgba(255,255,255,0.1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Background Color: ',
                  },
                },
                blockPosition: {
                  type: 'string',
                  uniforms: {
                    component: BottomBarSelect,
                    label: 'Block Position:',
                    value: 'center',
                    options: [
                      { key: 'Left', value: 'flex-start', label: 'Left' },
                      { key: 'Center', value: 'center', label: 'Center' },
                      { key: 'Right', value: 'flex-end', label: 'Right' },
                    ],
                  },
                },
                padding: {
                  type: 'number',
                  default: 10,
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default linkBlockPlugin;
